/*
 * Copyright (c) 2021-2021. Datafood srl
 * Developed by Revo Digital - revodigital.it
 * ---
 * Author: leonardoviada
 * File: history.ts
 * Project: mle-client
 * Committed last: 2021/11/11 @ 1745
 * ---
 */

import { createBrowserHistory } from 'history';

/**
 * Rappresenta la cronologia sui cui opera il router per le operazioni di render e navigazione.
 * @type {History<LocationState>}
 */
export const history = createBrowserHistory();
